import { useAppContext } from "contexts/AppContext";
import React, { useEffect, useState } from "react";

const InternetSpeedMeter = (props) => {
  const { appState, setAppState } = useAppContext();

  const {
    pingInterval = 5 * 60 * 1000, // every 5 minutes
    callbackFunctionOnNetworkDown,
    callbackFunctionOnNetworkTest,
  } = props;

  const [ping, setPing] = useState(null);

  const startTesting = (force = false) => {
    if (!force && !appState.settings.internet.online) return;

    if (!ping) {
      setTimeout(() => measure(), 1000);

      setPing(
        setInterval(() => {
          measure();
        }, pingInterval)
      );
    }
  };

  const stopTesting = () => {
    if (ping) {
      clearInterval(ping);
      setPing(null);
    }
  };

  const measurePing = async (url) => {
    const startTime = performance.now();
    try {
      await fetch(url, { method: "HEAD", cache: "no-cache" });
      const endTime = performance.now();
      return Math.round(endTime - startTime); // ms
    } catch (error) {
      return null; // connection failed
    }
  };

  const measureDownloadSpeed = async (fileUrl) => {
    const startTime = performance.now();
    try {
      const response = await fetch(fileUrl, { cache: "no-cache" });
      const blob = await response.blob();
      const endTime = performance.now();

      const durationSeconds = (endTime - startTime) / 1000;
      const bitsLoaded = blob.size * 8; // bytes → bits
      const speedMbps = bitsLoaded / durationSeconds / (1024 * 1024);

      return speedMbps;
    } catch (error) {
      return null; // download failed
    }
  };

  const measure = async () => {
    // ping checker
    const ping = await measurePing(`${import.meta.env.VITE_API}/ping/`);

    // speed checker
    const speed = await measureDownloadSpeed(
      "https://yavuzceliker.github.io/sample-images/image-1.jpg"
    );

    // quality measures
    let quality = "Unknown";

    if (ping === null || speed === null) {
      quality = "No Connection";
    } else if (ping < 150 && speed > 2) {
      quality = "Excellent";
    } else if (ping < 300 && speed > 1) {
      quality = "Good";
    } else {
      quality = "Poor";
    }

    setResults(ping, speed, quality);
    return { ping, speed, quality };
  };

  const setResults = (ping, speed, quality) => {
    const results = {
      ping,
      speed,
      quality,
      online: quality !== "No Connection",
    };

    setAppState({
      key: "settings.internet",
      value: results,
    });
  };

  const goOnline = () => {
    setAppState({
      key: "settings.internet.online",
      value: true,
    });
    startTesting(true);
  };

  const goOffline = () => {
    stopTesting();
    setAppState({
      key: "settings.internet.online",
      value: false,
    });
  };

  useEffect(() => {
    startTesting();

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    return () => {
      stopTesting();
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);
  return null;
};

export default InternetSpeedMeter;
